import { render } from "./ContentBuilder.vue?vue&type=template&id=b155bce4"
import script from "./ContentBuilder.vue?vue&type=script&lang=js"
export * from "./ContentBuilder.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__